import { render, staticRenderFns } from "./RF-Search.vue?vue&type=template&id=4f0b5550&scoped=true"
import script from "./RF-Search.vue?vue&type=script&lang=js"
export * from "./RF-Search.vue?vue&type=script&lang=js"
import style0 from "./RF-Search.vue?vue&type=style&index=0&id=4f0b5550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b5550",
  null
  
)

export default component.exports